<!-- Begin Modal Content -->
<h2 mat-dialog-title class="mat-mdc-dialog-title">
  {{ 'GALAXY.TABLE.COLUMN_SORT.MANAGE_TITLE' | translate }}
  @if (isMobileScreen()) {
    <button
      mat-icon-button
      mat-dialog-close
      class="close-modal"
      (click)="onClose()"
      tabindex="-1"
      >
      <mat-icon aria-label="Close">close</mat-icon>
    </button>
  }
</h2>

<mat-dialog-content class="advanced-column-organizer-content" autoFocus="false">
  <!-- Desktop View -->
  @if (!isMobileScreen()) {
    <div class="desktop-wrapper">
      <div class="desktop-left-pane">
        <ng-container *ngTemplateOutlet="filtered_checkablelist" />
      </div>
      <div class="desktop-right-pane">
        <ng-container *ngTemplateOutlet="filtered_dragable_list" />
      </div>
    </div>
  }

  <!-- Mobile View -->
  @if (isMobileScreen()) {
    <div class="mobile-wrapper">
      <mat-tab-group
        animationDuration="0ms"
        class="mobile-tabs"
        mat-align-tabs="center"
        [selectedIndex]="activeTab"
        (selectedTabChange)="setActiveTab($event.index.toString())"
        >
        <mat-tab [label]="'GALAXY.TABLE.COLUMN_SORT.TAB_CHOOSE' | translate">
          <div class="mobile-max-width">
            <ng-container *ngTemplateOutlet="filtered_checkablelist" />
          </div>
        </mat-tab>
        <mat-tab [label]="'GALAXY.TABLE.COLUMN_SORT.TAB_ARRANGE' | translate">
          <div class="mobile-max-width">
            <ng-container *ngTemplateOutlet="filtered_dragable_list" />
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close (click)="onClose()">{{ 'GALAXY.TABLE.COLUMN_SORT.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" mat-dialog-close (click)="save()">{{ 'GALAXY.TABLE.COLUMN_SORT.SAVE' | translate }}</button>
</mat-dialog-actions>
<!-- End Modal Content -->

<!-- Available Column List -->
<ng-template #filtered_checkablelist>
  <div class="section-container">
    <div class="section-content">
      <glxy-form-field suffixIcon="search" [showLabel]="false">
        <glxy-label>{{ 'GALAXY.TABLE.COLUMN_SORT.SEARCH_LABEL' | translate }}</glxy-label>
        <input type="text" [placeholder]="'GALAXY.TABLE.COLUMN_SORT.SEARCH_PLACEHOLDER' | translate" matInput [formControl]="searchControl" />
      </glxy-form-field>
      <!-- No Results -->
      @if (searchedGroups$ | async; as searchedGroups) {
        @if (searchedGroups.length === 0) {
          <div class="no-results">
            {{ 'GALAXY.TABLE.COLUMN_SORT.NO_RESULTS' | translate: { term: searchControl.value } }}
          </div>
        }
      }

      <!-- List of checkboxes -->
      @for (columnGroup of searchedGroups$ | async; track columnGroup) {
        @if (columnGroup.columns?.length !== 0) {
          <div class="column-group">
            <h4 class="column-group-name">
              {{ columnGroup.title }}
              <div class="select-all-controls">
                <a (click)="selectAll(columnGroup)">{{ 'GALAXY.TABLE.COLUMN_SORT.SELECT_ALL' | translate }}</a>
                |
                <a (click)="deselectAll(columnGroup)">{{ 'GALAXY.TABLE.COLUMN_SORT.DESELECT_ALL' | translate }}</a>
              </div>
            </h4>
            <ul class="column-group-list">
              @for (column of columnGroup.columns; track column) {
                <li class="column-group-item">
                  <mat-checkbox
                    color="primary"
                    [checked]="isActionsColumn(column) | async"
                    [disabled]="!!column.pinned"
                    (change)="setColumnVisibility(column.id, $event.checked)"
                    >
                    {{ column.title }}
                  </mat-checkbox>
                </li>
              }
            </ul>
          </div>
        }
      }
    </div>
  </div>
</ng-template>

<!-- Draggable List -->
<ng-template #filtered_dragable_list>
  <div class="section-container">
    <div class="section-header">{{ 'GALAXY.TABLE.COLUMN_SORT.ARRANGE_HEADER' | translate }}</div>

    <div class="section-content">
      <!-- Pinned to top -->
      @for (column of pinnedLeftColumns$ | async; track column) {
        @if (column?.id !== 'select') {
          <div class="draggable-row draggable-row--pinned">
            <div class="drag-icon">
              <mat-icon>lock</mat-icon>
            </div>
            <div class="name">{{ column.name }}</div>
          </div>
        }
      }

      <!-- Draggable Items -->
      <div cdkDropList>
        @for (columnInfo of selectedColumns$ | async; track columnInfo; let i = $index) {
          <div
            cdkDrag
            cdkDragLockAxis="y"
            [cdkDragData]="{ columnIndex: i, columnId: columnInfo.id }"
            (cdkDragDropped)="columnDroppedInList($event)"
            class="draggable-row"
            >
            <div class="drag-icon draggable" cdkDragHandle>
              <mat-icon>drag_handle</mat-icon>
            </div>
            @if (!isMobileScreen()) {
              <div class="name draggable" cdkDragHandle>
                {{ columnInfo.name }}
              </div>
            }
            @if (isMobileScreen()) {
              <div class="name">
                {{ columnInfo.name }}
              </div>
            }
            <div class="remove-icon">
              <button mat-icon-button (click)="setColumnVisibility(columnInfo.id, false)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div class="drag-placeholder" *cdkDragPlaceholder></div>
          </div>
        }
      </div>

      <!-- Pinned to Bottom -->
      @for (column of pinnedRightColumns$ | async; track column) {
        @if (column?.id !== 'select') {
          <div class="draggable-row draggable-row--pinned">
            <div class="drag-icon">
              <mat-icon>lock</mat-icon>
            </div>
            <div class="name">{{ column.name }}</div>
          </div>
        }
      }
    </div>
  </div>
</ng-template>
